import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import ManagerInsuranceCompaniesImportCaseTypes from './ManagerInsuranceCompaniesImportCaseTypes';

interface Props extends BaseModalProps {
	refresh: () => void;
}

const ManagerInsuranceCompaniesImportCaseTypesModal: React.FC<Props> = ({
	refresh,
	...props
}) => {
	return (
		<BaseModal {...props} title={'component.caseType.importFromFileTitle'}>
			<ManagerInsuranceCompaniesImportCaseTypes
				onClose={props.onClose}
				refresh={refresh}
			/>
		</BaseModal>
	);
};

export default ManagerInsuranceCompaniesImportCaseTypesModal;
